module.exports = __webpack_public_path__ + "img/jobs-mobile.e7a6c28.png";